export const  ApplyLeavesColumns = [
    "EmployeeCode",
    "EmployeeName",
    "TypeOfLeave",
    "FromDate",
    "ToDate",
    "NoOfDays",
    "LeaveReason",
    "LeaveAddress"  
];
